import { render, staticRenderFns } from "./PublicHolidays.vue?vue&type=template&id=56706f2a&scoped=true"
import script from "./PublicHolidays.vue?vue&type=script&lang=js"
export * from "./PublicHolidays.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidays.vue?vue&type=style&index=0&id=56706f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56706f2a",
  null
  
)

export default component.exports